export default "__VITE_ASSET__BYttXqID__"